import {
  MerchandisingSmallBannerProps,
  MerchandisingSmallBannerMBoxProps,
} from '../MerchandisingSmallBanner/MerchandisingSmallBanner.types';

export { MerchandisingSmallBanner, MerchandisingSmallBannerComp } from './MerchandisingSmallBanner';

export type { MerchandisingSmallBannerProps, MerchandisingSmallBannerMBoxProps };
